





















import NavList from '@/components/nav-list.vue';
import Layout from '@/packages/ae-layout';
import {routes} from '@/router';
import UiHeader from '@/views/header.vue';
import Vue from 'vue';
import VueClipboard from 'vue-clipboard2';
import {Component} from 'vue-property-decorator';

Vue.use(VueClipboard as any);
Vue.use(Layout);
@Component({
  components: {
    UiHeader,
    NavList
  }
})
export default class App extends Vue {

  public text1 = '';
  public text2 = '';
  get isDemo() {
    return this.$route.path.startsWith('/demo');
  }

  get routersName() {
    return routes.find(it => it.name === 'site').children;
  }

}
